import React from 'react'
import PropTypes from 'prop-types'

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardText from "components/Card/CardText";
import ImageUpload from "components/CustomUpload/ImageUpload.jsx";
import Icon from "@material-ui/core/Icon";

import {
  Container,
  Row,
  Col
} from 'reactstrap';

import { koreanAgeMan } from 'helpers/math';
import { ROLES_STRING } from 'constants/user';

function ProfileForDashboard(props) {
  const { org, user, role } = props;
  console.log('org = ', org);
  console.log('user = ', user);
  console.log('role = ', role);

  const onFileLoaded = (file, isRemoved = false) => {
    if (isRemoved) {
      // this.setState({ file: null, user: { ...this.state.user, profile_image_url: null } });
    } else {
      // this.setState({ file });
    }
  }

  return (
    <div>
      <Card className='p-5'>
        <Row>
          <Col>
            <Row>
              <Col xs={{ size: 'auto' }} className='d-flex mb-3'>
                <Icon size='large' color={"disabled"}>person</Icon>
                <span style={{ fontSize: '1.2em', fontWeight: 'bolder', marginLeft: 10 }}>{org?.기관명} ({ROLES_STRING[role?.role - 1]})</span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={{ size: 'auto' }}>
            <ImageUpload
              avatar
              addButtonProps={{
                color: "rose",
                round: true,
                size: 'sm'
              }}
              changeButtonProps={{
                color: "rose",
                round: true,
                size: 'sm'
              }}
              removeButtonProps={{
                color: "danger",
                round: true,
                size: 'sm'
              }}
              imageUrl={user?.profile_image_url}
              onFileLoaded={(file, isRemoved = false) => onFileLoaded(file, isRemoved)}
            />
          </Col>
          <Col>
            <Row>
              <Col>
                <div><li>이름: {user?.name}</li></div>
                <div><li>성별: {user?.gender === 1 ? '남자' : '여자'}</li></div>
                <div><li>생년월일: {user?.birthday} (만 {koreanAgeMan(user?.birthday)}세)</li></div>
              </Col>
              <Col>
                <div><li>상담사: 장윤정</li></div>
                <div><li>전화번호: {user?.phone}</li></div>
                <div><li>이메일: {user?.email}</li></div>
              </Col>
              <Col>
                <div><li>요양등급: 인지지원등급</li></div>
                <div><li>장기요양등급인정번호: 202020200202020</li></div>
                <div><li>자기소개: </li></div>
              </Col>
            </Row>

          </Col>
        </Row>
      </Card>
    </div>
  )
}

ProfileForDashboard.propTypes = {
  user: PropTypes.object.isRequired,
  org: PropTypes.object.isRequired,
  role: PropTypes.object.isRequired
}

export default ProfileForDashboard

